import type {PropsWithChildren} from 'react'

export const Ul = ({children, ...restProps}: PropsWithChildren) => (
  <ul
    className={'mb-spacing-12 ml-[1.8em] list-outside list-bullet [&>ul]:ml-[1.6em]'}
    data-testid={'_ul'}
    {...restProps}
  >
    {children}
  </ul>
)
